import { Injectable } from '@angular/core';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { ITaskTypeOnHold } from '../interfaces/task-type-on-hold';
import { BaseDataService } from './base.data.service';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class TaskTypeOnHoldService extends BaseDataService {
  url = '/api/tasktype-on-hold';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getAll(): Promise<ITaskTypeOnHold[]> {
    return this.handleRequest(
      this.http.get<ITaskTypeOnHold[]>(this.url),
      this.handlersFactory.getForReadAll(),
    );
  }

  saveItems(items: ITaskTypeOnHold[]): Promise<any> {
    return this.handleRequest(
      this.http.post(this.url, items),
      this.handlersFactory.getForUpdate('Task Types'),
    );
  }
}
